import React, { useState, useEffect, useLayoutEffect } from 'react';
import { Alert, ErrorScreen } from 'components/common';
import { useInventory, useUser } from 'components/hooks';
import { ROUTES } from 'consts';
import { formatProjectItems } from 'helpers';
import withRequest from 'hoc/withRequest';
import { useHistory, withRouter } from 'react-router-dom';
import { InventorySchema } from 'schemas';
import { CircularProgress, Backdrop } from '@mui/material';
import InventoryFormDumbOLD from './InventoryFormDumbOLD';


const InventoryEditSmartOLD = (props) => {
  const { match: { params } } = props;
  const { inventoryId, baseUrl } = params;
  const { parameters } = useUser();
  const projects = formatProjectItems(parameters);
  const history = useHistory();
  const { cleanUpMessage, error, success, putInventory, getInventory, data, isLoaded } = useInventory();

  const [defaultValues, setDefaultValues] = useState({
    name: '',
    project: projects[0].value,
    additionalVariables: ''
  });

  const findProject = (project) => {
    return projects.find(p => Number(p.value) === Number(project));
  }

  useEffect(() => {
    if (!!success.put) {
      history.push(ROUTES.INVENTORY_LIST);
    } else if (!!success.get) {
      handleData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success.get, success.put]);

  useLayoutEffect(() => {
    const query = {
      baseUrl: baseUrl,
      inventory: inventoryId
    }
    getInventory({ query });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCloseAlert = () => cleanUpMessage();

  const handleEdit = (data) => {
    const inventory = new InventorySchema();
    inventory.setValues(data);
    inventory.values.fromEdit = true;
    const project = findProject(data.project);
    inventory.values.baseUrl = project.base_url;
    putInventory({ body: inventory.getValues() });
  };

  const getProjectByBaseURL = () => {
    return projects.find(p => p.base_url === baseUrl)
  };

  function handleData() {
    const project = getProjectByBaseURL();
    const dataToSet = {
      name: inventoryId,
      project: project.value,
      additionalVariables: data
    }
    setDefaultValues(dataToSet);
  };

  return (
    <>
      { error.get ?
        (
          <ErrorScreen />
        ): isLoaded.get ?
        (
          <Backdrop
            invisible
            sx={{ zIndex: (theme) => theme.zIndex.drawer - 1 }}
            open={true}
          >
            <CircularProgress color="primary" />
          </Backdrop>
        ): (projects) ?
        (
          <InventoryFormDumbOLD
            defaultValues={defaultValues}
            handleOnSubmit={handleEdit}
            isEdit={true}
          />
        )
        :(
          <ErrorScreen />
        )
      }
      <Alert severity="error" handleClose={handleCloseAlert} open={error.put} message="common.errors.general.title" />
    </>
  );
};

export default withRequest(withRouter(InventoryEditSmartOLD));
